module.exports = function (element) {
  // https://html.spec.whatwg.org/multipage/form-elements.html#the-button-element:activation-behaviour
  // https://html.spec.whatwg.org/multipage/input.html#submit-button-state-(type=submit):input-activation-behavior
  // https://html.spec.whatwg.org/multipage/input.html#image-button-state-(type=image):input-activation-behavior
  // Note: attribute != property (for default values)
  return (
    (element.tagName === 'BUTTON' && element.type === 'submit') ||
    (element.tagName === 'INPUT' && (element.type === 'submit' || element.type === 'image'))
  );
};
